export default __webpack_public_path__ + "static/media/Beard_6_C2.51469727.svg";